import type { BasicFetch } from '../types/basicFetch';
import { concatByteArrays } from '../util/byteArray';
import { fetchByteRange } from './fetchByteRange';
import { inspectMoov } from './inspectMoov';
import type { Mp4Info } from './mp4Types';
import { tryGetMoovBox } from './parser';

export async function fetchAndInspectMoov(
  fetch: BasicFetch,
  url: string,
): Promise<Mp4Info> {

  let bytes = await fetchByteRange(fetch, url, 0, 100000);
  while (true) {
    const result = tryGetMoovBox(bytes);
    if (result === null) {
      throw new Error('mp4 is not fast started');
    }
    if (typeof result !== 'number') {
      return inspectMoov(result, true);
    }
    const end = result;
    const additionalBytes = await fetchByteRange(fetch, url, bytes.length, end);
    bytes = concatByteArrays([bytes, additionalBytes]);
  }
}
